var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-page"},[_c('div',{staticClass:"s-card"},[(!_vm.pageIsLoading)?_c('div',{staticClass:"static-page-content arx-content",domProps:{"innerHTML":_vm._s(_vm.staticPageContent)}}):_c('Spin',{attrs:{"fix":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }